export default function ({redirect, route, $config, localePath}) {
  const isMaintenance = $config.isMaintenance
  if (isMaintenance) {
    return redirect(localePath('/maintenance'))
  }
  if (isMaintenance === false && route.path === '/maintenance') {
    return redirect(localePath('/'))
  }
}
